import { render, staticRenderFns } from "./JudgeInfo.vue?vue&type=template&id=2ce170a6&scoped=true"
import script from "./JudgeInfo.vue?vue&type=script&lang=js"
export * from "./JudgeInfo.vue?vue&type=script&lang=js"
import style0 from "./JudgeInfo.vue?vue&type=style&index=0&id=2ce170a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce170a6",
  null
  
)

export default component.exports